import styled from 'styled-components';
import {
  IC_CHECKBOX,
  IC_PENDING_RED,
  IC_CHECKBOX_CHECKED,
  IC_CHECKBOX_CHECKED_GREEN,
  IC_CHECKBOX_CHECKED_BLUE,
  IC_CHECKBOX_RED,
} from '../../../Assets/images';

export const CheckboxStyled = styled.div`
  .form-check {
    margin: 0;
    padding: 0;
    cursor: pointer;
    display: flex;
    align-items: flex-start;

    label {
      max-width: calc(100% - 32px);
      line-height: 19px;
      cursor: pointer;
      color: ${(props) => props.theme.text.light};
    }
    .form-check-input[type='checkbox'] {
      width: 20px;
      min-width: 20px;
      height: 20px;
      background: url(${IC_CHECKBOX.src}) no-repeat 50% 50% / 100%;
      border: 0;
      margin: 0 7px 0 0;
      cursor: pointer;
      &:focus {
        box-shadow: 0 0 0;
      }
      &:checked {
        background: url(${IC_CHECKBOX_CHECKED.src}) no-repeat 50% 50% / 100%;
      }
    }
    &.asco-error {
      .form-check-input {
        background: url(${IC_CHECKBOX_RED?.src}) no-repeat 50% 50%;
      }
    }
    &.epharmacy {
      label {
        max-width: calc(100% - 32px);
        line-height: 19px;
        cursor: pointer;
        color: ${(props) => props.theme.text.dark};
      }
      .form-check-input[type='checkbox'] {
        width: 20px;
        min-width: 20px;
        height: 20px;
        background: url(${IC_CHECKBOX.src}) no-repeat 50% 50% / 100%;
        border: 0;
        margin: 0 7px 0 0;
        cursor: pointer;
        &:checked {
          background: url(${IC_CHECKBOX_CHECKED_GREEN.src}) no-repeat 50% 50% / 100%;
        }
      }
    }
  }
  &.epharmacy {
    .form-check {
      .form-check-input {
        &:checked {
          background: url(${IC_CHECKBOX_CHECKED_GREEN.src}) no-repeat 50% 50% / 100%;
        }
      }
    }
    &.error {
      .form-check {
        .form-check-input {
          background: url(${IC_CHECKBOX_RED?.src}) no-repeat 50% 50%;

          &:checked {
            background: url(${IC_CHECKBOX_CHECKED_GREEN.src}) no-repeat 50% 50% / 100%;
          }
        }
      }
    }
  }
  &.homecare {
      label {
        max-width: calc(100% - 27px) !important;
        line-height: 19px;
        cursor: pointer;
        color: ${(props) => props.theme.text.dark};
      }
      .form-check-input[type='checkbox'] {
        width: 20px;
        min-width: 20px;
        height: 20px;
        background: url(${IC_CHECKBOX.src}) no-repeat 50% 50% / 100%;
        border: 0;
        margin: 0 7px 0 0;
        cursor: pointer;
        &:checked {
         background: url(${IC_CHECKBOX_CHECKED_BLUE.src}) no-repeat 50% 50% / 100%;

        }
      }
    }
  }
  &.homecare {
    .form-check {
      .form-check-input {
        &:checked {
          background: url(${IC_CHECKBOX_CHECKED_BLUE.src}) no-repeat 50% 50% / 100%;
        }
      }
    }
    &.error {
      .form-check {
        .form-check-input {
          background: url(${IC_CHECKBOX_RED?.src}) no-repeat 50% 50%;

          &:checked {
            background: url(${IC_CHECKBOX_CHECKED_BLUE.src}) no-repeat 50% 50% / 100%;
          }
        }
      }
    }
  }
  .invalid-feedback {
    font-size: 12px;
    font-weight: 600;
    padding-left: 25px;
    background: url(${IC_PENDING_RED.src}) no-repeat 0 50% / 18px;
    color: ${(props) => props.theme.verification.red.main};
  }
`;
